export function saveSettings(numCorrect, numWrong, octaveOffset, totalSemitoneDistance) {
  const settings = {
    minNote: document.getElementById("minNote").value,
    maxNote: document.getElementById("maxNote").value,
    excludeBlackKeys: document.getElementById("excludeBlackKeys").checked,
    continuousMode: document.getElementById("continuousMode").checked,
    continuousSpeed: document.getElementById("continuousSpeedSlider").value,
    randomVelocity: document.getElementById("randomVelocity").checked,
    noteDuration: document.getElementById("noteDurationSlider").value,
    octaveOffset: octaveOffset,
    instrumentIndex: document.getElementById("instrumentSelect").value,
    stats: {
      numCorrect,
      numWrong,
      totalSemitoneDistance,
    },
  };
  localStorage.setItem("earTrainingSettings", JSON.stringify(settings));
}

export function loadSettings() {
  const settings = JSON.parse(localStorage.getItem("earTrainingSettings"));
  if (settings) {
    // Apply settings without triggering unnecessary events
    const minNote = document.getElementById("minNote");
    const maxNote = document.getElementById("maxNote");
    const excludeBlackKeys = document.getElementById("excludeBlackKeys");
    const continuousMode = document.getElementById("continuousMode");
    const continuousSpeedSlider = document.getElementById("continuousSpeedSlider");
    const speedValue = document.getElementById("speedValue");
    const noteDurationSlider = document.getElementById("noteDurationSlider");
    const durationValue = document.getElementById("durationValue");
    const randomVelocity = document.getElementById("randomVelocity");
    const instrumentSelect = document.getElementById("instrumentSelect");

    // Only update if values are different to avoid unnecessary UI updates
    if (minNote.value !== settings.minNote) minNote.value = settings.minNote;
    if (maxNote.value !== settings.maxNote) maxNote.value = settings.maxNote;
    if (excludeBlackKeys.checked !== settings.excludeBlackKeys) excludeBlackKeys.checked = settings.excludeBlackKeys;
    if (continuousMode.checked !== settings.continuousMode) continuousMode.checked = settings.continuousMode;
    
    const continuousSpeedValue = settings.continuousSpeed || "2.0";
    if (continuousSpeedSlider.value !== continuousSpeedValue) {
      continuousSpeedSlider.value = continuousSpeedValue;
      speedValue.textContent = `${continuousSpeedValue}s`;
    }
    
    const noteDurationValue = settings.noteDuration || "2.0";
    if (noteDurationSlider.value !== noteDurationValue) {
      noteDurationSlider.value = noteDurationValue;
      durationValue.textContent = `${noteDurationValue}s`;
    }
    
    if (randomVelocity.checked !== settings.randomVelocity) randomVelocity.checked = settings.randomVelocity;
    
    // Always allow instrument changes, even on instrument-specific pages
    if (settings.instrumentIndex !== undefined && instrumentSelect.value !== settings.instrumentIndex) {
      instrumentSelect.value = settings.instrumentIndex;
    }

    return {
      stats: {
        numCorrect: settings.stats.numCorrect,
        numWrong: settings.stats.numWrong,
        totalSemitoneDistance: settings.stats.totalSemitoneDistance || 0,
      },
      octaveOffset: settings.octaveOffset || 0,
    };
  }
  return {
    stats: { numCorrect: 0, numWrong: 0, totalSemitoneDistance: 0 },
    octaveOffset: 0,
  };
}
